import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
    // Auch in der Konsole loggen, damit man es per F12 sieht
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Caught:', error);
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] Component stack:', info?.componentStack);
  }

  reset = () => {
    this.setState({ error: null, info: null });
  };

  reload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    const stack = this.state.error?.stack || '(kein Stack)';
    const componentStack = this.state.info?.componentStack || '(kein Component Stack)';
    const message = this.state.error?.message || String(this.state.error);

    return (
      <div style={{
        padding: 20,
        fontFamily: 'system-ui, sans-serif',
        background: '#0d0d0d',
        color: '#f5f5f5',
        minHeight: '100vh',
        boxSizing: 'border-box',
      }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          <h1 style={{ color: '#d97706', marginTop: 0 }}>⚠️ Fehler abgefangen</h1>
          <p style={{ fontSize: 14, color: '#bbb', lineHeight: 1.5 }}>
            Die App ist gecrasht. Bitte mache einen <strong>Screenshot</strong> dieser Seite
            (besonders der Bereich „Component Stack") und sende ihn an Claude — damit lässt sich
            der Bug eindeutig zuordnen.
          </p>

          <div style={{ background: '#1a1a1a', border: '1px solid #c2410c', borderRadius: 8, padding: 14, marginTop: 16 }}>
            <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5, color: '#d97706', marginBottom: 6, fontWeight: 600 }}>
              Fehlermeldung
            </div>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#fca5a5', fontSize: 13 }}>{message}</pre>
          </div>

          <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: 8, padding: 14, marginTop: 12 }}>
            <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5, color: '#d97706', marginBottom: 6, fontWeight: 600 }}>
              Component Stack (wichtigster Teil)
            </div>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: 12, color: '#e5e5e5' }}>{componentStack}</pre>
          </div>

          <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: 8, padding: 14, marginTop: 12 }}>
            <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5, color: '#888', marginBottom: 6, fontWeight: 600 }}>
              JS-Stack
            </div>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: 12, color: '#999' }}>{stack}</pre>
          </div>

          <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
            <button onClick={this.reload}
              style={{ background: '#d97706', color: 'white', border: 'none', padding: '10px 20px', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>
              Seite neu laden
            </button>
            <button onClick={this.reset}
              style={{ background: 'transparent', color: '#bbb', border: '1px solid #444', padding: '10px 20px', borderRadius: 6, cursor: 'pointer' }}>
              Versuchen weiterzumachen
            </button>
          </div>
        </div>
      </div>
    );
  }
}
